import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RegisterCountryPage } from './register-country.page';

const routes: Routes = [
  {
    path: '',
    component: RegisterCountryPage
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterCountryPageRoutingModule {}
